import * as ReducerActions from "../actions/navBar";

const initialState = {
    sitePosition: 0,
    showButtons: true,
    backgroundImages: {}
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ReducerActions.UPDATE_SITE_POSITION:
            return { ...state, sitePosition: action.value, showButtons: false };
        case ReducerActions.UPDATE_SHOW_BUTTONS:
            return { ...state, showButtons: true };
        case ReducerActions.UPDATE_BACKGROUNDIMAGES:
            return { ...state, backgroundImages: action.value };
        default:
            return state;
    }
};

export default reducer;
